import { Component, Input, OnInit, Output } from '@angular/core';
import { AsyncSubject, Subject } from 'rxjs';
import { ResponseMessage } from '@sdbn/appclient';
import { ResponseStatus } from '@sdbn/appclient';
import { TransportDetailsLayoutService } from 'src/tmc-yard/components/transport-details/transport-details-layout.service';
import { LayoutDefinition, TransportDetails } from 'src/tmc-yard/components/transport-details/transport-details-model';
import { RegistrationStepperModel } from '../../model/registration-step-model';
import { TransportRegistration } from '../../model/transport-registration';
import { TransportRegistrationService } from '../../service/transport-registration.service';
import { TransportDetailsLayoutConverter } from 'src/tmc-yard/common/components/tmp/transport-details-layout-converter.service';
import { TransportDetailLayout, TransportDetailMode } from 'src/tmc-yard/common/configuration/transport.configuration';

@Component({
  selector: 'app-master-data',
  templateUrl: './master-data.component.html',
  styleUrls: ['./master-data.component.scss']
})
export class MasterDataComponent implements OnInit {

  TransportDetailMode = TransportDetailMode;

  responseMessages = new Array<ResponseMessage>();

  layoutDefinition: LayoutDefinition = null;
  layout: TransportDetailLayout;

  registration: TransportRegistration;
  private _stepperModel: RegistrationStepperModel;
  private _readonly = false;

  transportDetailsValid = false;

  @Input('registration') set setRegistration(value: TransportRegistration) {
    this.registration = value;
  }

  @Input() set stepperModel(stepperModel: RegistrationStepperModel) {
    console.log('Master.stepperModel', stepperModel);
    this._stepperModel = stepperModel;
    // hook to enable/disable next button
    this._stepperModel.stepCompleted = () => {
      return this.isStepCompleted();
    };

    this._stepperModel.beforeShowNextStep = () => {

      this.responseMessages = new Array<ResponseMessage>();

      const subject = new AsyncSubject<boolean>();
      try {
        this.transportRegistrationService.validateMasterdata(new TransportRegistration(this.registration)).subscribe(
          response => {
            if (response.status === ResponseStatus.SUCCESS) {
              subject.next(true);
              subject.complete();
            } else {
              this.responseMessages = response.responseMessages;
              subject.next(false);
              subject.complete();
            }
          },
          error => {
            subject.error(error);
            subject.complete();
          }
        );
      } catch (e) {
        subject.error(e);
        subject.complete();
      }

      return subject;

    };
  }

  @Input() set readonly(readonly: boolean) {
    this._readonly = readonly;
  }

  @Output() valueChange = new Subject<null>();

  constructor(
    private transportDetailsLayoutService: TransportDetailsLayoutService,
    private transportRegistrationService: TransportRegistrationService,
    private layoutConverter: TransportDetailsLayoutConverter
  ) {
    this.layoutDefinition = this.transportDetailsLayoutService.createRegisterTransportMasterdataLayout();
    this.layout = layoutConverter.convert(this.layoutDefinition);
  }

  ngOnInit(): void {
  }

  onValidStateChanges(valid: boolean) {
    this.transportDetailsValid = valid;
  }

  private isStepCompleted(): boolean {
    return this.transportDetailsValid;
  }

  public onValidChanged(valid: boolean) {
    this.transportDetailsValid = valid;
  }

  public onDirtyChanged(dirty: boolean) {
  }

  handleValueChange() {
    this.valueChange.next();
  }
}
